import { mapState } from 'vuex'

export default {
    data() {
        return {
            errors: []
        }
    },

    computed: {
        ...mapState('customer', ['profile'])
    },

    methods: {
        getField(fieldIndex) {
            return _.find(this.fields, function(field) {
                return fieldIndex == field.model
            })
        },

        resetErrors() {
            this.errors = []
        },

        addUnhandledError() {
            this.errors.push('Erreur inconnue, merci de recharger la page')
        },

        validateAddressStep(customerUsage) {
            this.resetErrors()

            let address, prefix

            if ('accounting' == customerUsage) {
                address = this.socialCertificate.accounting_address
                prefix = 'accounting_address'
            } else if ('social' == customerUsage) {
                address = this.socialCertificate.social_address
                prefix = 'social_address'
            } else {
                console.error('Uknown customer usage ' + customerUsage)

                return
            }

            // Same as existing address
            const sameAsExistingAddressField = this.getField(prefix + '.same_as_existing_address')

            if (!sameAsExistingAddressField || !sameAsExistingAddressField.hasOwnProperty('values')) {
                this.addUnhandledError()

                console.error('Same as existing address field does not have any values')

                return
            }

            if (!_.find(sameAsExistingAddressField.values, function(value) {
                return address.same_as_existing_address == value.id
            })) {
                this.errors.push("La valeur du champ utiliser une adresse existante est invalide")
            }

            // Other fields validation
            if ('other' == address.same_as_existing_address) {
                if (address.corporation_name && address.corporation_name.length > 80) {
                    this.errors.push("Le champ société est limité à 80 caractères")
                }

                if (address.first_name && address.first_name.length > 40) {
                    this.errors.push("Le champ prénom est limité à 40 caractères")
                }
                
                if (address.last_name && address.last_name.length > 40) {
                    this.errors.push("Le champ nom est limité à 40 caractères")
                }

                if (!address.corporation_name) {
                    if (!address.first_name || !address.last_name) {
                        this.errors.push("Les champs nom et prénom sont obligatoires quand le champ société n'est pas renseigné")
                    }
                }

                if (!address.street_line1) {
                    this.errors.push("Le champ adresse est obligatoire")
                }
                
                if (!address.zipcode) {
                    this.errors.push("Le champ code postal est obligatoire")
                }
                
                if (!address.city) {
                    this.errors.push("Le champ ville est obligatoire")
                }
                
                if (!address.country) {
                    this.errors.push("Le champ pays est obligatoire")
                } else {
                    const countryField = this.getField(prefix + '.country')

                    if (!countryField || !countryField.hasOwnProperty('values')) {
                        this.addUnhandledError()

                        console.error('Country field does not have any values')

                        return
                    }

                    if (!_.find(countryField.values, function(value) {
                        return address.country == value.id
                    })) {
                        this.errors.push("La valeur du champ pays est invalide")
                    }
                    
                    if ('US' == address.country) {
                        const usStateRegex = RegExp('^[0-9]{5}\-[0-9]{4}$')

                        if (!usStateRegex.test(address.zipcode)) {
                            this.errors.push("Le code postal d'une adresse aux Etats-Unis doit être saisi au format ZIP+4 (ex. 33701-4313)")
                        }

                        if (address.state) {
                            const stateField = this.getField(prefix + '.state')

                            if (!stateField || !stateField.hasOwnProperty('values')) {
                                this.addUnhandledError()

                                console.error('State field does not have any values')

                                return
                            }

                            if (!_.find(stateField.values, function(value) {
                                return address.state == value.id
                            })) {
                                this.errors.push("La valeur du champ état est invalide")
                            }
                        }
                    }
                }
            }

            if (this.errors.length === 0) {
                return true
            }

            return false
        },

        validateCustomerEmployeeStep(customerUsage) {
            this.resetErrors()

            const customer = this.socialCertificate.customer

            if (typeof customer.without_employee !== "boolean") {
                this.errors.push("La valeur du champ n'emploie aucun salarié est invalide")
            }

            if (this.errors.length === 0) {
                return true
            }

            return false
        }
    }
}


// WEBPACK FOOTER //
// ./client/mixins/socialCertificateFormStep.js